var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomquestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 23.5C24.1545 23.5 25.5 22.1545 25.5 20.5V20C25.5 18.3455 24.1545 17 22.5 17C20.8455 17 19.5 18.3455 19.5 20V20.5C19.5 22.1545 20.8455 23.5 22.5 23.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.161 24.9905C23.809 24.339 21.1915 24.339 18.839 24.9905C17.7565 25.2905 17 26.282 17 27.4025V29H28V27.4025C28 26.282 27.2435 25.2905 26.161 24.9905Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8983 9.55964C20.7303 9.21764 20.3823 9.00164 20.0013 9.00164H12.1183L12.9943 1.11164C13.0443 0.665638 12.7903 0.241638 12.3743 0.0736381C11.9573 -0.096362 11.4803 0.0356381 11.2073 0.390638L1.20728 13.3906C0.975277 13.6926 0.934276 14.1006 1.10328 14.4426C1.27228 14.7856 1.62028 15.0016 2.00128 15.0016H9.88428L9.00828 22.8916C8.95828 23.3376 9.21228 23.7616 9.62828 23.9296C9.74928 23.9786 9.87628 24.0016 10.0013 24.0016C10.3053 24.0016 10.6013 23.8626 10.7943 23.6116L20.7943 10.6116C21.0263 10.3096 21.0663 9.90164 20.8983 9.55964Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomquestions);
export default __webpack_public_path__ + "static/media/customquestions.cc72d6f4ed201669e0403304d5ac2f41.svg";
export { ForwardRef as ReactComponent };